import {combineReducers} from 'redux';

import global from '../states/global';
import stores from '../states/stores';

const rootReducer = combineReducers({
  global,
  stores
});

export default rootReducer
